import { render, staticRenderFns } from "./legendHandler.vue?vue&type=template&id=44fc23ec"
import script from "./legendHandler.vue?vue&type=script&lang=js"
export * from "./legendHandler.vue?vue&type=script&lang=js"
import style0 from "./legendHandler.vue?vue&type=style&index=0&id=44fc23ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports